import classNames from 'classnames';
import { ChangeEvent } from 'react';
import './RadioButton.css';

export type RadioButtonProps = {
  label: string;
  value: string;
  groupName?: string;
  isFullWidth?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  hasBorder?: boolean;
  checked?: boolean;
};

export const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  value,
  groupName,
  isFullWidth,
  onChange,
  hasBorder,
  checked,
}) => (
  <label
    className={classNames('radio-container', {
      'with-border': hasBorder,
      'flex-1': isFullWidth,
    })}
  >
    <input
      type="radio"
      value={value}
      name={groupName}
      onChange={onChange}
      checked={checked}
    />
    <span className="radio-checkmark"></span>
    {label}
  </label>
);
